import { handleDownloadFile } from '@services/formService'

import { ApiRequest } from '../baseService'

const baseRoute = 'file-management/file-descriptor'

function PreUploadInfo(data) {
  return ApiRequest.post(`${baseRoute}/pre-upload-info`, data)
}

function Upload(data) {
  return ApiRequest.post(`app/files/upload/`, data)
}

function UploadAnonymousFile(data, tenantId) {
  return ApiRequest.post(
    `app/files/uploadAnonymousFile?tenantId=` + tenantId,
    data
  )
}

function GetToken(id) {
  return ApiRequest.get(`${baseRoute}/download/${id}/token`)
}

function GenerateDownloadToken(fileIds) {
  return ApiRequest.get(`app/files/token?fileIds=${fileIds}`)
}

async function Download(file) {
  const res = await GenerateDownloadToken(file.fileId)
  const accessToken = res.data

  const downloadUrl =
    process.env.VITE_API_URL +
    `/api/app/files/download?accessToken=${accessToken}`

  handleDownloadFile(downloadUrl, file.name)
}

function GetFile(fileId) {
  return ApiRequest.get(`app/files/${fileId}`, { responseType: 'blob' })
}

function GetOnetimeAccessFile(fileId, tenantId) {
  return ApiRequest.get(
    `app/files/OnetimeAccessFile/${fileId}?tenantId=${tenantId}`,
    { responseType: 'blob' }
  )
}

async function DownloadAll(fileList) {
  if (!fileList.length) {
    return
  }

  let fileIds = fileList.map(file => file.fileId || file.id)
  fileIds = fileIds.join(',')

  const res = await GenerateDownloadToken(fileIds)
  const accessToken = res.data

  const downloadUrl =
    process.env.VITE_API_URL +
    `/api/app/files/download?accessToken=${accessToken}`
  handleDownloadFile(
    downloadUrl,
    fileList.length && fileList.length <= 1
      ? fileList[0].fileId
      : 'download.zip'
  )
}

// async function OpenFileInNewTab(fileId, fileName) {
//   const res = await GenerateDownloadToken(fileId)
//   const accessToken = res.data

//   const downloadUrl =
//     process.env.VITE_API_URL +
//     `/api/app/files/view/${fileName}?accessToken=${accessToken}`
//   window.open(downloadUrl, '_blank')
// }

async function OpenFileInPopup(fileId, fileName) {
  const res = await GenerateDownloadToken(fileId)
  const accessToken = res.data

  const downloadUrl =
    process.env.VITE_API_URL +
    `/api/app/files/download?accessToken=${accessToken}`

  try {
    // Tải file về dưới dạng blob
    const response = await fetch(downloadUrl)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const blob = await response.blob()
    const blobUrl = URL.createObjectURL(blob)

    // Tính toán vị trí để popup hiển thị ở chính giữa
    const width = 800
    const height = 600
    const left = (document.body.clientWidth - width) / 2
    const top = (document.body.clientHeight - height) / 2

    // Tạo popup window ở chính giữa màn hình
    const popup = window.open(
      '',
      '_blank',
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    )

    if (popup) {
      popup.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>${fileName}</title>
            <style>
              body {
                margin: 0;
                padding: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                min-height: 100vh;
              }
              iframe {
                width: 100%;
                height: 100vh;
              }
            </style>
          </head>
          <body>
            <iframe src="${blobUrl}" title="${fileName}"></iframe>
          </body>
        </html>
      `)
      popup.document.close()

      // Cleanup blob URL khi popup được đóng
      popup.addEventListener('beforeunload', () => {
        URL.revokeObjectURL(blobUrl)
      })
    }
  } catch (error) {
    console.error('Error loading file:', error)
    // Fallback về phương thức cũ nếu có lỗi
    const viewUrl =
      process.env.VITE_API_URL +
      `/api/app/files/view/${fileName}?accessToken=${accessToken}`

    // Tính toán vị trí cho fallback popup
    const width = 800
    const height = 600
    const left = (screen.width - width) / 2
    const top = (screen.height - height) / 2

    window.open(
      viewUrl,
      '_blank',
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    )
  }
}

const API = {
  PreUploadInfo,
  Upload,
  UploadAnonymousFile,
  GetToken,
  Download,
  DownloadAll,
  GetFile,
  GetOnetimeAccessFile,
  // OpenFileInNewTab,
  OpenFileInPopup,
  GenerateDownloadToken,
}

export default API
